import React, { useEffect, useRef, useState } from "react";
import styles from "./Gallery.module.css";

const photos = [
  {
    src: "https://images.unsplash.com/photo-1451337516015-6b6e9a44a8a3?auto=format&fit=crop&w=500&q=80",
    caption: "Golden hour dune bashing",
  },
  {
    src: "https://images.unsplash.com/photo-1509316785289-025f5b846b35?auto=format&fit=crop&w=500&q=80",
    caption: "Sunset over the red dunes",
  },
  {
    src: "https://images.unsplash.com/photo-1512100356356-de1b84283e18?auto=format&fit=crop&w=500&q=80",
    caption: "4x4 adventure trail",
  },
  {
    src: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=500&q=80",
    caption: "Evening desert camp",
  },
  {
    src: "https://images.unsplash.com/photo-1533130061792-64b345e4a833?auto=format&fit=crop&w=500&q=80",
    caption: "Quad bike thrills",
  },
  {
    src: "https://images.unsplash.com/photo-1519752594763-9edf9caea336?auto=format&fit=crop&w=500&q=80",
    caption: "Dune buggy ride",
  },
];

const AUTO_SCROLL_STEP = 1; // px per tick, keeps the motion slow and smooth
const AUTO_SCROLL_INTERVAL = 20; // ms
const RESUME_DELAY = 2500; // ms after user interaction before auto-scroll resumes

function Gallery() {
  const trackRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const resumeTimeoutRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return undefined;

    const timer = setInterval(() => {
      if (isPaused || !track) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 1) {
        track.scrollLeft = 0;
      } else {
        track.scrollLeft += AUTO_SCROLL_STEP;
      }
    }, AUTO_SCROLL_INTERVAL);

    return () => clearInterval(timer);
  }, [isPaused]);

  const pauseThenResume = () => {
    setIsPaused(true);
    if (resumeTimeoutRef.current) clearTimeout(resumeTimeoutRef.current);
    resumeTimeoutRef.current = setTimeout(() => {
      setIsPaused(false);
    }, RESUME_DELAY);
  };

  const scrollByAmount = (amount) => {
    if (trackRef.current) {
      trackRef.current.scrollBy({ left: amount, behavior: "smooth" });
    }
    pauseThenResume();
  };

  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>Moments From the Dunes</h2>

        <div className={styles.sliderWrap}>
          <button
            type="button"
            className={`${styles.arrow} ${styles.arrowLeft}`}
            onClick={() => scrollByAmount(-260)}
            aria-label="Scroll gallery left"
          >
            &#8249;
          </button>

          <div
            className={styles.track}
            ref={trackRef}
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={() => setIsPaused(true)}
            onTouchEnd={pauseThenResume}
            onScroll={() => {
              // treat any manual scroll/drag as user interaction
            }}
          >
            {photos.concat(photos).map((photo, idx) => (
              <div key={idx} className={styles.tile}>
                <img
                  src={photo.src}
                  alt={photo.caption}
                  className={styles.image}
                  draggable="false"
                />
                <span className={styles.caption}>{photo.caption}</span>
              </div>
            ))}
          </div>

          <button
            type="button"
            className={`${styles.arrow} ${styles.arrowRight}`}
            onClick={() => scrollByAmount(260)}
            aria-label="Scroll gallery right"
          >
            &#8250;
          </button>
        </div>
      </div>
    </section>
  );
}

export default Gallery;
